// extracted by mini-css-extract-plugin
var _1 = "src-js-components-footer--Footer-module__contentContainer";
export { _1 as "contentContainer" }
